import { useState, useEffect } from 'react';
import AddToAnyButton from './AddToAnyButton';

const ShareVehicleButton = () => {
  // this fix ssr crashing
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setVisible(true);
    }, 10);
  }, []);

  if (!visible) return null;

  return (
    <div>
      <AddToAnyButton />
    </div>
  );
};

ShareVehicleButton.propTypes = {};

ShareVehicleButton.defaultProps = {};

export default ShareVehicleButton;
